import { fg } from '@atlaskit/platform-feature-flags';

import { ProductKeys3P, type ProductKeys } from '../../../../constants/products';

type FederatedEmailProduct =
	| (typeof ProductKeys3P)['Gmail']
	| (typeof ProductKeys3P)['OutlookMail'];

const isFederatedEmailProduct = (productKey: ProductKeys): productKey is FederatedEmailProduct =>
	productKey === ProductKeys3P.Gmail || productKey === ProductKeys3P.OutlookMail;

export const getFederatedEmailResultCountLimit = ({
	productKey,
	count,
	hasMoreGmailResults,
	hasMoreOutlookMailResults,
}: {
	productKey: ProductKeys;
	count?: number;
	hasMoreGmailResults?: boolean;
	hasMoreOutlookMailResults?: boolean;
}): number | undefined => {
	if (!isFederatedEmailProduct(productKey)) {
		return undefined;
	}

	const isFederatedEmailCountEnabled =
		productKey === ProductKeys3P.Gmail
			? fg('formula_3p_gmail_result_count')
			: fg('formula_3p_outlook_result_count');

	if (!isFederatedEmailCountEnabled) {
		return undefined;
	}

	const hasMoreResults =
		productKey === ProductKeys3P.Gmail ? hasMoreGmailResults : hasMoreOutlookMailResults;

	if (!hasMoreResults || count === undefined) {
		return undefined;
	}

	return count;
};
